<template>
  <div class="listPage">
    <el-tabs v-model="activeName" @tab-click="clickTab">
      <el-tab-pane label="预报警列表" name="1">
        <el-row>
          <el-col :span="4">
            <div class="block">
              <span>开始时间：</span>
              <el-date-picker
                v-model="startTime"
                type="datetime"
                size="mini"
                placeholder="开始时间"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="block">
              <span>结束时间：</span>
              <el-date-picker
                v-model="endTime"
                type="datetime"
                size="mini"
                placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4">
            <span>选择装置：</span>
            <el-select v-model="selectValue" placeholder="请选择" size="mini">
              <el-option
                v-for="item in options"
                :key="item.workShopEnName"
                :label="item.workShopEnName"
                :value="item.workShopEnName"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" size="mini" @click="clickQueryBtn()">查询</el-button>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" size="mini" @click="test"
              >返回上一级</el-button
            >
          </el-col>
        </el-row>
        <br>
        <el-table :data="tableData" stripe style="width: 100%" max-height="950" v-if="isShowListInfo">
          <el-table-column label="序号" align="center" width="80">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="报警时刻" align="center" width="200">
          </el-table-column>
          <el-table-column prop="modelName" label="报警设备" align="center" width="200">
          </el-table-column>
          <el-table-column prop="workShopEnName" label="所属装置"  align="center" width="120">
          </el-table-column>
          <el-table-column prop="alarmIndType" label="报警指标"  align="center" width="120">
          </el-table-column>
          <el-table-column prop="alarmLevel" label="报警类别"  align="center" width="120">
          </el-table-column>
          <el-table-column prop="alarmReason" label="报警原因"  align="center" width="665">
          </el-table-column>
          <el-table-column prop="operAnalysis" label="操作分析"  align="center" width="400">
          </el-table-column>
        </el-table>
        <br>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 25, 30]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total=total>
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="预报警启用列表" name="2">
        <el-table :data="alarmswitchTableData" stripe style="width: 100%" max-height="950">
          <el-table-column label="序号" align="center" width="180">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="modelName" label="报警设备"  align="center" width="400">
          </el-table-column>
          <el-table-column prop="workShopEnName" label="所属装置"  align="center" width="400">
          </el-table-column>
          <el-table-column prop="alarmIndType" label="报警指标"  align="center" width="400">
          </el-table-column>
          <el-table-column prop="operTime" label="禁用时间"  align="center" width="400">
          </el-table-column>
          <el-table-column label="当前状态"  align="center" width="140">
            <template slot-scope="scope">
                <el-button @click="clickEnableButton(scope.row)" type="primary" size="mini">{{ scope.row.status == "1"?"启用":"禁用" }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getAlarminfo , getAlarmSwitch , upDateAlarmStatus } from "@/api/alarm"
import { workShops } from "@/api/wormBox"
export default {
  data() {
    return {
      activeName: "1",
      startTime: new Date(new Date().getTime() - 1 * 60 * 60 * 1000),
      endTime: new Date(),
      options: [
        // {
        //   workShopEnName: "装置1",
        // },
        // {
        //   workShopEnName: "装置2",
        // },
      ],
      selectValue: "",
      total:null,
      currentPage:1,
      pageSize:10,
      tableData: [
        // {
        //   createTime: "2024-06-06 00:00:00",
        //   modelName:"反应器",
        //   workShopEnName:"双酚A",
        //   alarmIndType:"稳定指标",
        //   alarmLevel:"预警",
        //   alarmReason:"E2873循环流量FI2806.PV当前值19.69，超出高限，该值正常范围是0~17.80",
        //   operAnalysis:"该流量升高可能跟XXXXX有关，请及时调整XXXXXX"
        // }
      ],
      msg:"",
      alarmswitchMsg:"",
      isShowListInfo:false,
      alarmswitchTableData:[]
    };
  },
  methods: {
    test() {
      this.$router.back();
    },
    clickTab() {
      if(this.activeName == "2"){
        this.getAlarmSwitchList()
      }
    },
    async clickEnableButton(row){
        let params = {
          alarmIndType:row.alarmIndType,
          status:row.status == 0 ? 1 : 0 ,
          modelFullName:row.modelFullName
        }
        const { code } = await upDateAlarmStatus(params)
        if( code == 200 ){
          this.getAlarmSwitchList()
        }
    },
    clickQueryBtn(){
      this.getAlarminfoList()
    },
    handleSizeChange(val) {
        this.pageSize = val
        this.getAlarminfoList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getAlarminfoList()
    },
    async getAlarminfoList() {
      this.msg = this.$message({
        duration: 0,
        type: "info",
        message:"加载中..."
      });
      const {code , resultData} = await getAlarminfo({startTime:this.startTime.getTime(), endTime:this.endTime.getTime(), workShopEnName:this.selectValue ,pageNum:this.currentPage,pageSize:this.pageSize})
      if( code == 200 ){
        this.total = resultData.total
        this.tableData = resultData.list
        this.isShowListInfo = true
        this.msg.close()
        this.$message({
          message: '成功',
          type: 'success'
        });
      }else{
        this.msg.close()
      }
    },
    async getAlarmSwitchList() {
      this.alarmswitchMsg = this.$message({
        duration: 0,
        type: "info",
        message:"加载中..."
      });
      const {code , resultData} = await getAlarmSwitch()
      if( code == 200 ){
        this.alarmswitchTableData = resultData.list
        this.isShowListInfo = true
        this.alarmswitchMsg.close()
        this.$message({
          message: '成功',
          type: 'success'
        });
      }else{
        this.alarmswitchMsg.close()
      }
    },
    async getWorkShopsList(){
      const {code , resultData} = await  workShops()
      if( code == 200 ){
        this.options = resultData
        this.selectValue = resultData[0].workShopEnName
        this.getAlarminfoList()
      }
    }
  },
  mounted(){
    this.getWorkShopsList()
  },
  destroyed(){
    this.msg = ""
    this.alarmswitchMsg = ""
  }
};
</script>

<style lang="less" scoped>
div {
  color: white;
}
</style>